import { Log } from '../../../AuxillaryService/Log';
import { BroadsignAd } from './types';
import AdQueue from '../AdQueue';
import { ReachAPI } from '../../../ReachApi';
import { RequestAdsBroadsignAPISuccessResponse } from '../../../ReachApi/broadsignTypes';

export class BroadsignApiHelper {
    /**
     * Fetches ads from the Broadsign ad serving API.
     */
    static async fetchAds(
        security: ReachAPI.Security,
        widgetId: number,
        numberOfAds: number,
        height: number,
        width: number,
        duration: number,
        muteAds: boolean,
        adQueue: AdQueue<BroadsignAd>,
        playerUuid: string | null
    ): Promise<void> {
        const identifer = playerUuid ?? String(widgetId);
        const isAudioAllowed = !muteAds;
        let response: RequestAdsBroadsignAPISuccessResponse;
        try {
            response = await ReachAPI.broadsign.requestAds(
                security,
                widgetId,
                width,
                height,
                isAudioAllowed,
                numberOfAds,
                duration
            );
        } catch (error: unknown) {
            const errorMessage = String(error);
            Log.Error(
                `Broadsign, failed to fetch ads for device ${identifer} ${errorMessage}`,
                null,
                __fileline
            );
            return;
        }

        if (response.textStatus === 'nocontent') {
            Log.Info(`Broadsign: No content available for device ${identifer}`, null, __fileline);
            return;
        }

        const ads = response.data.ads;

        for (const anAd of ads) {
            const ad: BroadsignAd = {
                adId: anAd.id,
                assetUrl: anAd.asset_url,
                isFallback: false,
                duration: Number(anAd.length_in_seconds),
                playcount: 0,
                lastAdInLoop: false,
                popUrl: anAd.proof_of_play_url,
                expires: Number(anAd.lease_expiry),
                filetype: anAd.mime_type.includes('video') ? 'video' : 'image',
            };

            adQueue.enqueue(ad);
            Log.Info(
                ` Broadsign: pushed ad with ad id ${ad.adId} with id ${ad.adId}`,
                null,
                __fileline
            );
        }
    }

    /**
     * Sends proof of play via the pop url
     * returned with an advertisement creative from
     * the Broadsign ad serving API.
     */
    static async sendProofOfPlay(
        ad: Pick<BroadsignAd, 'adId' | 'popUrl'>,
        playerUuid: string | null,
        security: ReachAPI.Security,
        widgetId: number
    ): Promise<void> {
        const identifier: string = playerUuid ?? String(widgetId);
        try {
            await ReachAPI.broadsign.sendProofOfPlay(security, ad.popUrl, widgetId);
        } catch (error: unknown) {
            const errorMessage = String(error);
            Log.Error(
                `Broadsign: failed to send proof of play for ad ${ad.adId} on device ${identifier} ${errorMessage}`,
                null,
                __fileline
            );
            return;
        }
        Log.Info(
            `Broadsign: Succesfully sent proof of play for ad ${ad.adId} on device ${identifier}`,
            null,
            __fileline
        );
    }
}
